import React from 'react';

const PingPage = () => {

    const d = new Date();

    return <p style={{ marginTop: 80, textAlign: 'center',  }}>{d.toString()}</p>

}

export default PingPage;